export const AMLTransactionStatusEnum = {
  1: {
    key: 1,
    name: "Pass",
    value: "Pass",
    title: "Pass",
    classes: "c-success-light",
  },
  2: {
    key: 2,
    name: "Fail",
    value: "Fail",
    title: "Fail",
    classes: "c-primary",
  },
  3: {
    key: 3,
    name: "Pending",
    value: "Pending",
    classes: "c-primary",
    title: "Pending",
  },
  4: {
    key: 4,
    name: "NeedRevision",
    value: "NeedRevision",
    classes: "c-primary",
    title: "Need Revision",
  },
  5: {
    key: 5,
    name: "WithdrawTransaction",
    value: "WithdrawTransaction",
    classes: "c-primary",
    title: "With draw Transaction",
  },
  6: {
    key: 6,
    name: "AutoWithdraw",
    value: "AutoWithdraw",
    classes: "c-primary",
    title: "Auto Withdraw",
  },
  7: {
    key: 7,
    name: "Resubmitted",
    value: "Resubmitted",
    classes: "c-primary",
    title: "Need Revision",
  },
  8: {
    key: 8,
    name: "Approved",
    value: "Approved",
    classes: "c-primary",
    title: "Need Revision",
  },
  9: {
    key: 9,
    name: "Rejected",
    value: "Rejected",
    classes: "c-primary",
    title: "Rejected",
  },
  10: {
    key: 10,
    name: "ReassignedToRequester",
    value: "ReassignedToRequester",
    classes: "c-primary",
    title: "Reassigned To Requester",
  },
};
